import React, { Component } from 'react';

import { Pie } from 'react-chartjs-2';
import _ from 'lodash';
import { type } from '@testing-library/user-event/dist/type';

class PieChart extends Component {
	constructor() {
		super();
		this.state = {
			// totMemoryCards: 0,
			// tempdata: [],
			assetsNumbers: [],
			tempData2: [],
			bgColor: [],
			borderColor: [],
			tempDatav2: [],

			otherC: 0,
		};
	}
	getAllPieChartData2 = (type) => {
		let otherAssetCount = 0;
		let bgColor = [];
		let borderColor = [];
		let totc = 0;

		let tempData2 = [];
		this.props.data.map((asset) => {
			let assetItem = _.filter(this.props.assetTypeOptions, {
				value: asset.type,
			});

			if (_.size(assetItem) === 0) {
				otherAssetCount = otherAssetCount + asset.activeCount;
			} else if (_.size(assetItem) > 0) {
				tempData2.push(asset.activeCount);
				bgColor.push(assetItem[0]['color']);
				borderColor.push(assetItem[0]['color']);
				totc += asset.activeCount;
			}
		});
		if (otherAssetCount > 0) {
			tempData2.push(otherAssetCount);
			bgColor.push('#707070');
			borderColor.push('#707070');
			totc += otherAssetCount;
		}
		let tempDatav2 = tempData2.map((asset) => {
			return (asset = ~~((asset / totc) * 100));
		});
		this.setState({
			tempDatav2,
			bgColor,
			borderColor,
		});
	};

	componentDidMount = () => {
		this.getAllPieChartData2(this.props);
	};
	componentWillReceiveProps = (nextProps) => {
		this.getAllPieChartData2(nextProps);
	};

	render() {
		let otherAssetCount = 0;
		return (
			<>
				<div
					style={{
						width: '30vw',
						minWidth: '419px',
						backgroundColor: ' #262626',
						padding: '12px 16px',
						color: '#898989',
					}}
				>
					<p>Total Assets</p>
				</div>
				<div
					className="main-bod"
					style={{
						width: '30vw',
						minWidth: '419px',
						border: '0.5px solid #383838',
						padding: '10px',
						// marginTop: '30px',
						marginBottom: '30px',
						display: 'flex',
						alignItems: 'center',
						backgroundColor: '#1C1C1C',
						// gap: '30px',
						justifyContent: 'space-between',
					}}
				>
					<div
						className="chart-container"
						style={{
							height: '160px',
							width: '160px',
						}}
					>
						<Pie
							data={{
								datasets: [
									{
										label: '% of Assets',
										// data: this.state.tempdata,
										data: this.state.tempDatav2,
										backgroundColor: this.state.bgColor,
										borderColor: this.state.borderColor,
										borderWidth: 1,
									},
								],
							}}
						/>
					</div>
					<div
						className="labels-bod"
						style={{
							display: 'flex',
							flexDirection: 'column',
							width: 'calc(100% - 220px)',
							gap: '15px',
						}}
					>
						{this.props.data.map((asset) => {
							let assetItem = _.filter(this.props.assetTypeOptions, {
								value: asset.type,
							});

							if (_.size(assetItem) === 0) {
								otherAssetCount = otherAssetCount + asset.activeCount;
							}

							return (
								<>
									{_.size(assetItem) > 0 && (
										<div
											className="sublabel"
											style={{
												display: 'flex',
												alignItems: 'center',
												// gap: '8px',
												color: 'white',
												width: '100%',
												justifyContent: 'space-between',
											}}
										>
											<div
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: '16px',
												}}
											>
												<div
													className="blocks"
													style={{
														backgroundColor: assetItem[0]['color'],
														height: '16px',
														width: '16px',
														borderRadius: '50%',
													}}
												></div>
												<div>{assetItem[0]['label']}</div>
											</div>

											<div>{asset.activeCount}</div>
										</div>
									)}
								</>
							);
						})}

						{otherAssetCount > 0 ? (
							<div
								className="sublabel"
								style={{
									display: 'flex',
									alignItems: 'center',
									// gap: '8px',
									color: 'white',
									width: '100%',
									justifyContent: 'space-between',
								}}
							>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: '16px',
									}}
								>
									{' '}
									<div
										className="blocks"
										style={{
											backgroundColor: '#707070',
											height: '16px',
											width: '16px',
											borderRadius: '50%',
										}}
									></div>
									<div>{'Other'}</div>
								</div>

								<div>{otherAssetCount}</div>
							</div>
						) : (
							''
						)}
					</div>
				</div>
			</>
		);
	}
}
export default PieChart;
